<template>
  <i :class="`${icon} text-${variant} cursor-pointer ${btnClass}`"
     data-bs-toggle="tooltip"
     :title="tooltip"
     @click="$emit('click')"
  />
</template>

<script>

export default {
  // Định nghĩa props
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    btnClass: {
      type: String,
      default: 'btn-light',
    },
    icon: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tooltipInstance: null,
    };
  },
};
</script>

<style scoped>

</style>
